import { differenceBy, isEmpty, set, unionWith } from 'lodash'
import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { fireToastError } from '../../actions/toasts/fireToast'
import requestSaveObject from '../../actions/userObject/profile/requestUpdateUserProfile'
import i18n from '../../i18n'
import updatePriceConfiguration from '../../models/Price/updatePriceConfiguration'
import updatePriceKids from '../../models/Price/updatePriceKids'
import { IStore } from '../../reducers'
import { PriceConfigurationActions, PriceGridAction } from '../../reducers/price/actionNames'
import { getAccessToken } from '../../reducers/userAccount/selectors/credentials'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import { getUserProfile } from '../../reducers/userObject/selectors/settings'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import updatePriceTaxKids from '../../models/Price/updatePriceTaxKids'
import { getRoomModalEditOpenId, getRoomModalEditSettings, getPriceSettingsAction, getSettingsData } from '../../reducers/price/selectors/price'
import { PriceSettingsTab } from '../../containers/PriceSettingsContent/PriceSettingsNavigator'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import fireToastSucces from '../../actions/toasts/fireToastSucces'
import updatePriceConfigurationPrice from '../../models/Price/updatePriceConfigurationPrice'
import updatePriceConfigurationAcc from '../../models/Price/updatePriceConfigurationAcc'
import updatePriceConfigurationFee from '../../models/Price/updatePriceConfigurationFee'
import updatePriceConfigurationFood from '../../models/Price/updatePriceConfigurationFood'
import { FeedingType } from '../../models/Object'
import { IPriceConfiguration } from '../../models/Price'
import {
  normalizeBookingPlanRateValue,
  normalizeBookingPlanRatesForSave,
} from '../../models/Price/groupBookingPlanRatesByName'
import updatePriceConfigurationTax from '../../models/Price/updatePriceConfigurationTax'
import RequestFetchUserProfile from '../../actions/userObject/profile/requestFetchUserProfile'
import saveRoomSettings from '../../models/Price/saveRoomSettings'
import createFetch from '../../models/fetch'
import savePriceMultiAdjust, {
  isDependentPlanPercentMode,
  percentChangeToOffset,
  resolveDependentPriceChangeAmount,
} from '../../models/Price/savePriceMultiAdjust'
import { getBookingObjects } from '../../reducers/booking/selectors'
import {
  getSortedRoomsByPosition,
  precomputedPricesCache,
  precomputedRestrictionsCache,
} from '../../reducers/bookingCalendar/selectors/rooms'
import togglePriceDisplayed from '../../models/Price/togglePriceDisplayed'
import { PriceEditModalActions } from '../../reducers/priceEdit/actionNames'
import setPriceSwitchStatus from '../../models/Price/setPriceSwitchStatus'
import { getNewPrices } from './getPrices'
import { navigateOrNotifyHost } from '../../utils/reactNativeWebViewNavigate'
import { fetchGlobalRoomSettings } from './loadConfiguration'
import { getUserCurrency } from '../../reducers/userObject/selectors/object'
import { hasFeeCommissionDialogChanges } from '../../models/Price/collectFeeChangeDialogRooms'
import {
  getPriceSettingsTabFromPendingAction,
  shouldLeavePriceSettingsToGrid,
} from '../../models/Price/priceSettingsPendingAction'

function* updateConfiguration(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdatePriceConfiguratuion)
    const actionNamesKids = fetchActionsName(
      ActionNames.UpdatePriceConfiguratuionKids,
    )
    const actionNamesKidsTax = fetchActionsName(
      ActionNames.UpdatePriceConfiguratuionKidsTax,
    )

    const userData = yield Effects.select(getUserProfile)
    const kids = yield Effects.select(
      (state: IStore) => state.price.config.kids,
    )
    const kidsTax = yield Effects.select(
      (state: IStore) => state.price.config.kids_tax,
    )

    const [
      { calendarId, service },
      { service: kidService },
      { service: kidServiceTax },
      objectId,
    ] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.take(actionNamesKids.output),
      Effects.take(actionNamesKidsTax.output),
      Effects.select(getUserObjectId),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          updatePriceConfiguration,
        ),
      ),
      Effects.put(
        callFetch(
          actionNamesKids.input,
          actionNamesKids.output,
          updatePriceKids,
        ),
      ),
      Effects.put(
        callFetch(
          actionNamesKidsTax.input,
          actionNamesKidsTax.output,
          updatePriceTaxKids,
        ),
      ),
      Effects.put(
        requestSaveObject({ ...userData, idCurrency: action.values.currency }),
      ),
    ])

    let deletedKids = differenceBy(kids, action.values.kids, 'id')
    let deletedKidsTax = differenceBy(kidsTax, action.values.kids_tax, 'id')
    deletedKids = deletedKids.map(kid => ({ ...kid, deleted: 1 }))
    deletedKidsTax = deletedKidsTax.map(kid => ({ ...kid, deleted: 1 }))

    const unionKids = unionWith(
      deletedKids,
      action.values.kids,
      kids,
      (val: any, othVal: any) => {
        return (
          val.id !== undefined &&
          othVal.id !== undefined &&
          val.id === othVal.id
        )
      },
    )
    const unionKidsTax = unionWith(
      deletedKidsTax,
      action.values.kids_tax,
      kidsTax,
      (val: any, othVal: any) => {
        return (
          val.id !== undefined &&
          othVal.id !== undefined &&
          val.id === othVal.id
        )
      },
    )

    yield Effects.call(service, action.values, objectId, String(calendarId))
    yield Effects.call(
      kidService,
      { ...action.values, kids: unionKids },
      objectId,
      String(calendarId),
    )
    yield Effects.call(
      kidServiceTax,
      { ...action.values, kids_tax: unionKidsTax },
      objectId,
      String(calendarId),
    )

    yield Effects.put({ type: PriceConfigurationActions.SetDefaultConfig })
    yield Effects.put({type: PriceGridAction.SetDisplayed})

    const accessToken = yield Effects.select(getAccessToken)

    if ('routerHistory' in window) {
      if (
        'returnOnSave' in ((window as any).routerHistory.location.state || {})
      ) {
        ;(window as any).routerHistory.push({
          pathname: (window as any).routerHistory.location.state.returnOnSave,
          state: {
            doNotRefresh: true,
            force: true,
          },
        })
      } else {
        navigateOrNotifyHost('/price/set', {
          mobile: String(action.mobile) === '1',
          mobileUrl: `/price/set?mobile=1&accessToken=${accessToken}`,
        })
      }
    }
    yield Effects.put({
      toggle: false,
      type: PriceConfigurationActions.ToggleLoading,
    })
  } catch (e) {
    yield Effects.put({
      toggle: false,
      type: PriceConfigurationActions.ToggleLoading,
    })
    //console.error(e)
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

function *SaveNewConfiguration(action) {
  const data = yield Effects.select(getSettingsData)
  const tab = yield Effects.select((state: IStore) => state.price.priceSettingsTab)
  const idObject = yield Effects.select(getUserObjectId)
  const idCalendar = yield Effects.select(getCalendarId)
  const currency = yield Effects.select(getUserProfile)
  const config: IPriceConfiguration = yield Effects.select((state: IStore) => state.price.config)
  let actionNames: any = ''
  let actionToDo: any = undefined



  let dataToSave = {}

  let kids = yield Effects.select(
    (state: IStore) => state.price.config.kids,
  )

  kids = kids.filter(k => !isEmpty(k))

  const kidsTax = yield Effects.select(
    (state: IStore) => state.price.config.kids_tax,
  )

  const errors = validate(data, tab)

  if(errors) {
    yield Effects.put({
      type: PriceConfigurationActions.SetErrorsSettings,
      payload: errors
    })
    yield Effects.put({
      type: PriceConfigurationActions.SetConfigurationLoading,
      payload: false,
    })
    return
  }

  switch (tab) {
    case PriceSettingsTab.Price:
      actionToDo = updatePriceConfigurationPrice
      let deletedKids = differenceBy(kids, data.kids, 'id')
      deletedKids = deletedKids.map(kid => ({ ...kid, deleted: 1 }))
      const unionKids = unionWith(
        deletedKids,
        data.kids.filter(k => !isEmpty(k)),
        kids,
        (val: any, othVal: any) => {
          return (
            val.id !== undefined &&
            othVal.id !== undefined &&
            val.id === othVal.id
          )
        },
      )

      actionNames = fetchActionsName(ActionNames.UpdatePriceConfiguratuionPrice)

      dataToSave = {
        id_object: idObject,
        id_calendar: idCalendar,
        currency: currency.idCurrency,
        short_stay_price: data.short_rent_price? data.short_rent_price_days: 0,
        long_stay_price: data.long_rent_price? data.long_rent_price_days: 0,
        weekend_price: data.weekend_price,
        kids_price: data.children_price,
        price_per_person: data.based_price,
        kids: unionKids.map(k => ({
          ...k,
          age_from: Number(k.ageFrom),
          age_to: Number(k.ageTo),
        })),
      }
      break
    case PriceSettingsTab.Availability:
      actionToDo = updatePriceConfigurationAcc

      actionNames = fetchActionsName(ActionNames.UpdatePriceConfiguratuionAcc)

      dataToSave = {
        id_object: idObject,
        id_calendar: idCalendar,
        restrictions: Object.values(data).some(Boolean),
        restriction_min_stay: data.min_arrival_length,
        restriction_min_stay_thru: data.restrictions_min_length,
        restriction_max_stay: data.max_arrival_length,
        restriction_max_stay_thru: data.restrictions_max_length,
        restriction_exact_stay: data.restrictions_exact_stay,
        restriction_close_at_arrival: data.checkin_blocking,
        restriction_close_at_departure: data.checkout_blocking,
        restriction_min_before_arrival: data.reservation_min_advance,
        restriction_max_before_arrival: data.reservation_max_advance,
      }
      break
    case PriceSettingsTab.Fee:
      if(!action.force) {
        const [
          bookingObjects,
          roomSettingsGlobal,
          airbnbListings,
          rooms,
          currency,
        ] = yield Effects.all([
          Effects.select((state: IStore) => state.booking.bookingObjects),
          Effects.select((state: IStore) => state.price.roomSettingsGlobal),
          Effects.select((state: IStore) => state.integration.listings),
          Effects.select(getSortedRoomsByPosition),
          Effects.select(getUserCurrency),
        ])

        if (
          hasFeeCommissionDialogChanges(
            config,
            data,
            rooms,
            bookingObjects,
            roomSettingsGlobal,
            airbnbListings,
            currency,
          )
        ) {
          yield Effects.put({
            type: PriceConfigurationActions.OpenFeeModal,
            payload: true,
          })
          yield Effects.put({
            type: PriceConfigurationActions.SetConfigurationLoading,
            payload: false,
          })
          yield Effects.put({
            type: PriceConfigurationActions.CloseModal,
            payload: false,
          })
          return
        }
      }
      actionToDo = updatePriceConfigurationFee

      actionNames = fetchActionsName(ActionNames.UpdatePriceConfiguratuionFee)

      // rates — tylko Booking.com (prowizja per plan); Airbnb bez tego pola
      const bookingRatesFromForm =
        data.bookingRates && typeof data.bookingRates === 'object'
          ? data.bookingRates
          : null
      const configBooking = config.integrations
        .booking as { rates?: Record<string, number> }
      const configRates =
        configBooking && configBooking.rates ? configBooking.rates : {}
      const bookingRates = normalizeBookingPlanRatesForSave(
        bookingRatesFromForm && Object.keys(bookingRatesFromForm).length > 0
          ? bookingRatesFromForm
          : configRates,
      )

      const hasPerPlanBookingRates =
        bookingRates &&
        typeof bookingRates === 'object' &&
        Object.keys(bookingRates).length > 0

      // Per plan: globalna prowizja % nie jest używana — backend / kontrakt: percent = 0, wartości w rates.
      const bookingPercent = hasPerPlanBookingRates
        ? 0
        : normalizeBookingPlanRateValue(data.bookingPrice)

      dataToSave = {
        id_object: idObject,
        id_calendar: idCalendar,
        integrations: {
          booking: {
            active: data.booking,
            percent: bookingPercent,
            rates: bookingRates,
          },
          airbnb: {
            active: data.airbnb,
            percent: normalizeBookingPlanRateValue(data.airbnbPrice),
          },
        },
      }
      break
    case PriceSettingsTab.Accommodation:
      actionToDo = updatePriceConfigurationFood

      actionNames = fetchActionsName(ActionNames.UpdatePriceConfiguratuionFood)

      dataToSave = {
        id_object: idObject,
        id_calendar: idCalendar,
        food: data.feeding,
        food_bb: Number(data[FeedingType.Breakfast].price),
        food_hb: Number(data[FeedingType.WithDinner].price),
        food_fb: Number(data[FeedingType.FullFood].price),
        food_bb_included: data[FeedingType.Breakfast].included,
        food_hb_included: data[FeedingType.WithDinner].included,
        food_fb_included: data[FeedingType.FullFood].included,
      }
      break
    case PriceSettingsTab.Currency:
      actionToDo = updatePriceConfigurationPrice

      actionNames = fetchActionsName(ActionNames.UpdatePriceConfiguratuionPrice)

      dataToSave = {
        id_object: idObject,
        id_calendar: idCalendar,
        currency: data,
        short_stay_price: config.stayShortTo,
        long_stay_price: config.stayLongFrom,
        weekend_price:  config.weekendPrice,
        kids_price: config.kidsPrice,
        price_per_person: config.pricePerPerson,
        kids: config.kids.map(k => ({
          ...k,
          age_from: Number(k.ageFrom),
          age_to: Number(k.ageTo),
        })),
      }
      break
      case PriceSettingsTab.Tax:
      actionToDo = updatePriceConfigurationTax
      let deletedKidsTax = differenceBy(kidsTax, data.kids, 'id')
      deletedKidsTax = deletedKidsTax.map(kid => ({ ...kid, deleted: 1 }))

      const unionKidsTax = unionWith(
        deletedKidsTax,
        data.kids,
        kidsTax,
        (val: any, othVal: any) => {
          return (
            val.id !== undefined &&
            othVal.id !== undefined &&
            val.id === othVal.id
          )
        },
      )

      actionNames = fetchActionsName(ActionNames.UpdatePriceConfiguratuionTax)


      dataToSave = {
        id_object: idObject,
        id_calendar: idCalendar,
        localtax: data.tax,
        localtax_adults: data.price,
        localtax_included: data.included,
        localtax_days: data.localtax_day,
        taxes: unionKidsTax.map(k => ({
          ...k,
          age_from: Number(k.ageFrom),
          age_to: Number(k.ageTo),
          taxes: k.price || k.taxes,
        })).filter(k => k.age_from !== undefined && k.age_to !== undefined && k.taxes !== undefined && k.age_from !== null && k.age_to !== null && k.taxes !== null),
      }
      break
  }

  try {
    const [
      { service },
    ] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          actionToDo,
        ),
      ),
    ])

    yield Effects.call(
      service,
      dataToSave,
      idObject,
      idCalendar,
    )

    yield Effects.put({
      type: PriceConfigurationActions.SetDiff,
      payload: false,
    })
    yield Effects.put({ type: PriceConfigurationActions.RequestForConfiguration })
    yield Effects.put(RequestFetchUserProfile())
    yield Effects.put(fireToastSucces(i18n.t('user_settings_updated'), 5000, 'Main', 'PriceConfigurationSaved'))
    const pendingAction = yield Effects.select(getPriceSettingsAction)
    const pendingTab = getPriceSettingsTabFromPendingAction(pendingAction)
    if (pendingTab !== null) {
      yield Effects.put({
        type: PriceConfigurationActions.ChangePriceSettingsTab,
        payload: pendingTab,
      })
    } else if (shouldLeavePriceSettingsToGrid(pendingAction)) {
      navigateOrNotifyHost('/price/set')
    }
    if (pendingAction) {
      yield Effects.put({
        type: PriceConfigurationActions.CloseModal,
        payload: false,
        action: '',
      })
    }
    if(!action.desktop){
      yield Effects.put({type: PriceConfigurationActions.ChangePriceSettingsTab, payload: PriceSettingsTab.None})
      yield Effects.put({type: PriceConfigurationActions.CloseModal, payload: false})
    }
  } catch (e){
    //console.log(e)
    yield Effects.put({
      type: PriceConfigurationActions.SetConfigurationLoading,
      payload: false,
    })
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }

}

const validate = (data: any, tab: PriceSettingsTab): any => {

  let errors = {}
  switch (tab) {
    case PriceSettingsTab.Accommodation:
      if(!data.feeding) return false

      if(data[FeedingType.Breakfast].active && !data[FeedingType.Breakfast].included){
        if(!data[FeedingType.Breakfast].price) errors[FeedingType.Breakfast] = 'BED_11807_meals_error_empty'
      }

      if(data[FeedingType.WithDinner].active && !data[FeedingType.WithDinner].included){
        if(!data[FeedingType.WithDinner].price) errors[FeedingType.WithDinner] = 'BED_11807_meals_error_empty'
      }

      if(data[FeedingType.FullFood].active && !data[FeedingType.FullFood].included){
        if(!data[FeedingType.FullFood].price) errors[FeedingType.FullFood] = 'BED_11807_meals_error_empty'
      }

      if(errors[FeedingType.Breakfast] && errors[FeedingType.WithDinner] && errors[FeedingType.FullFood]){
        return isEmpty(errors)? false : errors
      }
      
     return false

    case PriceSettingsTab.Tax:
      if(!data.tax) return false

      if(!data.price || data.price === '0.00') errors['price'] = 'BED_11804_local_tax_error_empty'
      if(data.kids && data.kids.length > 0) {
        data.kids.forEach((kid, index) => {
          if(!kid.price) errors[`kids[${index}].price`] = 'BED_11804_local_tax_error_empty'
          if(kid.ageFrom === undefined) errors[`kids[${index}].ageFrom`] = 'BED_11804_local_tax_error_age'
          if(kid.ageTo === undefined) errors[`kids[${index}].ageTo`] = 'BED_11804_local_tax_error_age'
        })
      }
      return isEmpty(errors)? false : errors
    case PriceSettingsTab.Price:
        if (
          data['short_rent_price'] &&
          (data['short_rent_price_days'] === undefined || data['short_rent_price_days'] === 0 || data['short_rent_price_days'] === '0' || data['short_rent_price_days'] === '')
        ) {
          errors = {
            ...errors,
            short_rent_price_days: i18n.t('BED_11814_error_empty'),
          }
        } else if (
          data['short_rent_price'] &&
          data['long_rent_price'] &&
          data['short_rent_price_days'] >= data['long_rent_price_days']
        ) {
          errors = {
            ...errors,
            short_rent_price_days: 'BED_11814_error_short_stay',
          }
        } else {
          delete errors['short_rent_price_days']
        }

        if (
          data['long_rent_price'] &&
          data['long_rent_price_days'] === undefined
        ) {
          errors = {
            ...errors,
            long_rent_price_days: 'BED_11814_error_empty',
          }
        } else if (
          data['short_rent_price'] &&
          data['long_rent_price'] &&
          data['long_rent_price_days'] <= data['short_rent_price_days']
        ) {
          errors = {
            ...errors,
            long_rent_price_days: 'BED_11814_error_long_stay',
          }
        } else {
          delete errors['long_rent_price_days']
        }

      if(data.children_price && data.kids && data.kids.length > 0) {
        data.kids.forEach((kid, index) => {
          if(kid.ageFrom === undefined) errors[`kids[${index}].ageFrom`] = 'BED_11804_local_tax_error_age'
          if(kid.ageTo === undefined) errors[`kids[${index}].ageTo`] = 'BED_11804_local_tax_error_age'
        })
      }

        return isEmpty(errors)? false : errors
    default:
      return false;
  }
}

function* setDisplayed(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SetPriceDisplayed)
    const [
      { calendarId, service }
    ] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          togglePriceDisplayed,
        ),
      )
    ])
    const idObject = yield Effects.select(getUserObjectId)

    yield Effects.call(service, String(idObject), String(calendarId))


  } catch (e) {
  }
}

function* setSwitchStatus(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SetPriceSwitch)
    const [
      { calendarId, service }
    ] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          setPriceSwitchStatus,
        ),
      )
    ])
    const idObject = yield Effects.select(getUserObjectId)


    yield Effects.call(service, action.payload, String(idObject), String(calendarId))


  } catch (e) {
  }
}

function* putRoomSettings(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.PutRoomSettingsGrid)
    const roomSettings = yield Effects.select(getRoomModalEditSettings)
    const roomId = yield Effects.select(getRoomModalEditOpenId)
    const [
      { calendarId, service }
    ] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          saveRoomSettings,
        ),
      )
    ])

    const rooms = yield Effects.select(getSortedRoomsByPosition)

    const roomSize = rooms.find(r => String(r.id) === String(roomId)).roomSize

    const errorsA = validateAirbnb(roomSettings.integrations.airbnb)
    const errorsB = validateBooking(roomSettings.integrations.booking, roomSize)


    if(errorsA || errorsB){
      yield Effects.put({type: PriceGridAction.SetRoomSettingsAirbnbErrors, payload: errorsA})
      yield Effects.put({type: PriceGridAction.SetRoomSettingsBookingErrors, payload: errorsB})
      return
    } else {
      yield Effects.call(service, {
        ...roomSettings,
        integrations: {
          ...roomSettings.integrations,
          airbnb: {
            ...roomSettings.integrations.airbnb,
            additional_after_persons: roomSettings.integrations.airbnb.additional_after_persons? roomSettings.integrations.airbnb.additional_after_persons: 1,
            price: roomSettings.integrations.airbnb && roomSettings.integrations.airbnb.price === '0.00'? '0': roomSettings.integrations.airbnb.price
          },
        }
      }, roomId, String(calendarId))

      // Booking.com: plany zależne — /pricemulti/adjust (nie dotyczy Airbnb)
      const bookingObjects = yield Effects.select(getBookingObjects)
      const allRooms = (bookingObjects || []).reduce(
        (acc: any[], obj: any) => acc.concat(obj.rooms || []),
        [],
      )
      const bookingObject = (bookingObjects || []).find((o: any) =>
        (o.mappings || []).some((m: any) =>
          (m.bed_booking_rooms || []).some(
            (id: any) => String(id) === String(roomId),
          ),
        ),
      )
      const idIntegration =
        bookingObject && bookingObject.id != null
          ? String(bookingObject.id)
          : null
      const mapping = (bookingObject?.mappings || []).find((m: any) =>
        (m.bed_booking_rooms || []).some(
          (id: any) => String(id) === String(roomId),
        ),
      )
      const bookingRoom =
        mapping &&
        allRooms.find(
          (r: any) => String(r.id) === String(mapping.booking_id),
        )
      const dependentPlans =
        bookingRoom && Array.isArray(bookingRoom.pricing)
          ? bookingRoom.pricing.filter(
              (p: any) => Number(p.is_child) === 1 && !p.deleted,
            )
          : []

      if (idIntegration && dependentPlans.length > 0) {
        const accessToken = yield Effects.select(getAccessToken)
        const bookingIntegrations = Array.isArray(
          roomSettings.integrations?.booking,
        )
          ? roomSettings.integrations.booking
          : []
        if (accessToken) {
          const fetchInstance = createFetch(accessToken)
          const postAdjust = savePriceMultiAdjust({
            fetch: fetchInstance.authorizedFetch,
          })
          for (const dep of dependentPlans) {
            const int = bookingIntegrations.find(
              (b: any) =>
                String(b.booking_id_pricing) === String(dep.booking_id),
            )
            if (!isDependentPlanPercentMode(int, dep)) {
              continue
            }
            const amount = resolveDependentPriceChangeAmount(int, dep)
            const offset = percentChangeToOffset(amount)
            try {
              yield Effects.call(postAdjust, {
                id_integration: idIntegration,
                id_calendar: String(calendarId),
                id_room: String(roomId),
                offset: String(offset),
                rate: String(dep.booking_id),
              })
            } catch (adjustErr) {
              yield Effects.put(
                fireToastError(
                  i18n.t('error_server_response_2'),
                  5000,
                  'Main',
                  'ServerError',
                ),
              )
            }
          }
        }
      }
    }



  yield Effects.put({type: PriceGridAction.OpenRoomEditModal, payload: false})
    yield Effects.put({type: PriceGridAction.SetNewPricesLoading, payload:true})
  yield * fetchGlobalRoomSettings({}) //Effects.put({type: PriceGridAction.LoadGlobalRoomSettings})
    yield Effects.put({type: PriceGridAction.SetNewPricesLoading, payload:true})

    precomputedPricesCache.delete(roomId)
    precomputedPricesCache.delete(`pricesMapped-${roomId}`)
    precomputedRestrictionsCache.delete(roomId)
    precomputedRestrictionsCache.delete(`restrictionsMapped-${roomId}`)

   yield * getNewPrices({reload: true}) //Effects.put({type: PriceGridAction.RequestNewPrices, reload: true})

    //yield  Effects.put({ type: 'FETCH_BOOKING_MULTI' })
    //yield Effects.put(getAirbnbIntegration())
    yield Effects.put(fireToastSucces(i18n.t('user_settings_updated')))
    if(action.backToEdit) {
      yield Effects.put({
        type: PriceEditModalActions.OpenPriceEditModal,
        pType: action.pType ? action.pType : 'BedBooking',
        roomId: action.roomId
      })
    }

  } catch (e) {
    const errorsa = {}
    errorsa['additional_price_per_person'] = i18n.t('OUT_25_extra_guest_error')
    yield Effects.put({type: PriceGridAction.SetRoomSettingsAirbnbErrors, payload: errorsa})
    //console.error(e)
  }
}

const validateBooking = (data:any, roomSize): any => {
  let errors = {}
  data.forEach((int) => {
    if(int.active) {
      if(int.percent === undefined || int.percent === null || int.percent === '') set(errors, `${int.booking_id_pricing}.percent`, 'BED_11802_commission_error_empty')
      if(int.price === 0 || int.price === '0.00' || int.price==='0') {
        int.price = undefined
      }
    }

    if(int.persons && int.persons.standard !== 0 && int.persons.persons.length !== 0){
      Array.from(new Array(Number(roomSize))).forEach((_, index) => {
        if(int.persons.persons[index+1] === undefined || int.persons.persons[index+1] === null || int.persons.persons[index+1].value === '' || int.persons.persons[index+1].value === undefined || int.persons.persons[index+1].value === null) {
          if((index+1) !== int.persons.standard) {
            set(errors, `${int.booking_id_pricing}.persons.persons.${index+1}.value`, 'BED_11816_derived_pricing_error_empty_field')
          }
        }
      })
    }
  })

  return isEmpty(errors)? false : errors
}

const validateAirbnb = (data: any): any => {
  let errors = {}
  if(data.active) {
    if(data.percent === undefined || data.percent === null || data.percent === '') errors['percent'] = 'BED_11802_commission_error_empty'
  }
  return isEmpty(errors)? false : errors

}


export default function*() {
  yield Effects.takeEvery(
    PriceConfigurationActions.UpdateConfiguration,
    updateConfiguration,
  )
  yield Effects.takeEvery(
    PriceConfigurationActions.SaveConfiguration,
    SaveNewConfiguration,
  )
  yield Effects.takeEvery(
    PriceGridAction.SaveRoomSettings,
    putRoomSettings)
  yield Effects.takeEvery(PriceGridAction.SetDisplayed, setDisplayed)
  yield Effects.takeEvery(PriceGridAction.ExpandRooms, setSwitchStatus)
}
